import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/slices/store";

export const useTabAccess = (): Record<string, string[]> => {
  const authUser = useSelector((state: RootState) => state.login.user.user);
  return useMemo(() => {
    try { return JSON.parse(authUser.tab_access || '{}') || {}; }
    catch { return {}; }
  }, [authUser.tab_access]);
};
